<kl-form-container
  [mode]="mode"
  [title]="
    title + (mode === 'edit' || mode == 'view' ? entity.document_num : '')
  "
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow || errorShow"
  [alertType]="'error'"
  (onCloseAlert)="alertShow = false"
  (onCommitSave)="commitSave($event)"
>
  <form #VirtualOrderReceiptForm="ngForm" novalidate>
    <accordion>
      <accordion-group
        [isOpen]="isOpenFirstAccordion"
        (isOpenChange)="isOpenFirstAccordion = $event"
      >
        <div accordion-heading class="clearfix">
          {{ "general" | translate }}
          <span class="badge badge-secondary float-right pull-right"
            ><i
              class="fa"
              [ngClass]="isOpenFirstAccordion ? 'fa-minus' : 'fa-plus'"
            ></i
          ></span>
        </div>
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-md-4 col-sm-12">
              <div class="form-group row">
                <label for="document_num" class="col-md-4 col-sm-12">
                  <small
                    >{{ "document_num" | translate }}
                    <i class="text-danger">*</i></small
                  >
                </label>
                <div class="col-md-8 col-sm-12">
                  <div class="input-group">
                    <input
                      class="form-control form-control-sm"
                      id="document_num"
                      #focusElement
                      maxlength="20"
                      [(ngModel)]="entity.document_num"
                      (ngModelChange)="formChange(true)"
                      #documentNo="ngModel"
                      [disabled]="isReadOnly"
                      [ngClass]="
                        alertShow && documentNo.invalid ? 'errorInput' : ''
                      "
                      name="document_num"
                      required
                    />
                    <div
                      class="input-group-append"
                      (click)="isReadOnly ? '' : generateNumber()"
                    >
                      <span
                        class="input-group-text transparent code-icon"
                        id="basic-addon2"
                      >
                        <i
                          [hidden]="!generateCodeSpin"
                          class="fal fa-spinner fa-spin fa-fw"
                        ></i>
                        <img
                          [hidden]="generateCodeSpin"
                          src="assets/img/keys.svg"
                          style="width: 20px"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                    *ngIf="alertShow && documentNo.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-4 col-sm-12">
                  <label for="documentDate">
                    <small
                      >{{ "date" | translate }} / {{ "time" | translate }}
                      <i class="text-danger">*</i></small
                    >
                  </label>
                </div>
                <div class="col-md-8 col-sm-12 row pr-0">
                  <div class="col-md-8 col-sm-12 pr-0">
                    <p-calendar
                      id="documentDate"
                      [style]="{ width: '100%' }"
                      [locale]="locale"
                      [dateFormat]="dateFormatString"
                      styleClass="dateInput"
                      [disabled]="isReadOnly"
                      [showIcon]="true"
                      utc="true"
                      #documentDate="ngModel"
                      name="documentDate"
                      [ngClass]="alertShow && documentDate.invalid ? 'err' : ''"
                      (onSelect)="formChange(true)"
                      [(ngModel)]="document_date"
                      required
                    >
                      <ng-template pTemplate="date" let-date>
                        <span>{{ date.day | translate }}</span>
                      </ng-template>
                    </p-calendar>
                    <a
                      class="calendarInput inputClear"
                      [hidden]="!document_date || isReadOnly"
                      (click)="document_date = null; formChange(true)"
                    >
                      <i class="fal fa-close"></i>
                    </a>
                    <div
                      *ngIf="alertShow && documentDate.invalid"
                      class="errorMessage"
                    >
                      {{ "important_area" | translate }}
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-12 pr-0">
                    <p-calendar
                      id="documentTime"
                      name="documentTime"
                      styleClass="dateInput"
                      #documentTime="ngModel"
                      [disabled]="isReadOnly"
                      [ngClass]="alertShow && documentTime.invalid ? 'err' : ''"
                      [showIcon]="true"
                      (onSelect)="formChange(true)"
                      [(ngModel)]="document_time"
                      [timeOnly]="true"
                      required
                    >
                    </p-calendar>
                    <div
                      *ngIf="alertShow && documentTime.invalid"
                      class="errorMessage"
                    >
                      {{ "important_area" | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-4 col-sm-12" for="externalDocumentNO">
                  <small>{{ "external_document_num" | translate }}</small>
                </label>
                <div class="col-md-8 col-sm-12">
                  <input
                    id="externalDocumentNO"
                    name="externalDocumentNO"
                    #focusElement
                    maxlength="20"
                    [disabled]="isReadOnly"
                    (ngModelChange)="formChange(true)"
                    [(ngModel)]="entity.external_document_num"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="col-md-12 col-sm-12 line-through">
                <label>{{ "dealers_information" | translate }}</label>
                <span class="through"></span>
              </div>
              <div class="form-group row">
                <label for="current_account_code" class="col-md-4 col-sm-12">
                  <small>{{ "code" | translate }}</small>
                </label>
                <div class="col-md-8 col-sm-12">
                  <div class="input-group">
                    <input
                      class="form-control form-control-sm"
                      [value]="entity.current_account?.code"
                      [ngClass]="
                        alertShow && !entity.current_account ? 'errorInput' : ''
                      "
                      [disabled]="true"
                      id="current_account_code"
                      name="current_account_code"
                      required
                    />
                    <a
                      class="inputClear"
                      [hidden]="
                        !entity.current_account || isReadOnly || curr_account_id
                      "
                      (click)="clearCurrentAccount()"
                    >
                      <i class="fal fa-close"></i>
                    </a>
                    <div
                      class="input-group-append"
                      (click)="
                        !isReadOnly && !curr_account_id
                          ? setModal(
                              'current_accounts',
                              'CURRENT_ACCOUNT',
                              CurrentAccountList,
                              '02.01.01'
                            )
                          : ''
                      "
                    >
                      <span
                        class="input-group-text transparent"
                        id="basic-addon342"
                      >
                        <i class="fal fa-ellipsis-h" aria-hidden="true"></i>
                      </span>
                    </div>
                  </div>
                  <div
                    *ngIf="alertShow && !entity.current_account"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="current_account_description"
                  class="col-md-4 col-sm-12"
                >
                  <small>{{ "description" | translate }}</small>
                </label>
                <div class="col-md-8 col-sm-12">
                  <input
                    class="form-control form-control-sm"
                    [value]="entity.current_account?.description"
                    [disabled]="true"
                    id="current_account_description"
                    name="current_account_description"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="col-md-12 col-sm-12 line-through">
                <label>{{ "customer_information" | translate }}</label>
                <span class="through"></span>
              </div>
              <div class="form-group row">
                <label for="customer_code" class="col-md-4 col-sm-12">
                  <small>{{ "code" | translate }}</small>
                </label>
                <div class="col-md-8 col-sm-12">
                  <div class="input-group">
                    <input
                      class="form-control form-control-sm"
                      [value]="entity.customer?.code"
                      [ngClass]="
                        alertShow && !entity.customer ? 'errorInput' : ''
                      "
                      [disabled]="true"
                      id="customer_code"
                      name="customer_code"
                      required
                    />
                    <a
                      class="inputClear"
                      [hidden]="!entity.customer || isReadOnly"
                      (click)="clearCustomer()"
                    >
                      <i class="fal fa-close"></i>
                    </a>
                    <div
                      class="input-group-append"
                      (click)="
                        !isReadOnly
                          ? setModal(
                              'customers',
                              'CUSTOMER',
                              CustomerList,
                              '03.01.01'
                            )
                          : ''
                      "
                    >
                      <span class="input-group-text transparent">
                        <i class="fal fa-ellipsis-h" aria-hidden="true"></i>
                      </span>
                    </div>
                  </div>
                  <div
                    *ngIf="alertShow && !entity.customer"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="customer_description" class="col-md-4 col-sm-12">
                  <small>{{ "description" | translate }}</small>
                </label>
                <div class="col-md-8 col-sm-12">
                  <input
                    class="form-control form-control-sm"
                    [value]="entity.customer?.description"
                    [disabled]="true"
                    id="customer_description"
                    name="customer_description"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </accordion-group>
      <accordion-group
        [isOpen]="isOpenThirdAccordion"
        (isOpenChange)="openLineAccordion($event)"
      >
        <div accordion-heading class="clearfix">
          {{ "lines" | translate }}
          <span class="badge badge-secondary float-right pull-right">
            <i
              class="fa"
              [ngClass]="isOpenThirdAccordion ? 'fa-minus' : 'fa-plus'"
            ></i>
          </span>
        </div>
        <div class="col-md-12 col-sm-12 row position-relative pr-0 mr-0 mb-2">
          <button
            *ngIf="!isReadOnly"
            type="button"
            class="btn btn-sm btn-default mr-1"
            style="width: 15%"
            (click)="addNewLine()"
          >
            {{ "add_new_line" | translate }} +
          </button>
          <div style="position: relative; width: 84%">
            <kl-alert
              [message]="'material_not_found' | translate"
              [show]="notFoundMaterial"
              [type]="'error'"
              (onClose)="notFoundMaterial = false"
            ></kl-alert>
          </div>
        </div>
        <kl-form-entry-grid
          *ngIf="showLineGrid"
          (onColumnChange)="changeLineColumn($event)"
          (onLostFocus)="changeLineColumn($event)"
          (onAddNew)="addNewLine($event)"
          (onDelete)="deleteLine()"
          (onRowChange)="changeLineRow($event)"
          (onCellEdit)="editLineCell($event)"
          [gridName]="'grdVirtualOrderPurchaseLine'"
          [moduleName]="'VIRTUAL_ORDER_RECEIPT_FORM'"
          [parentModuleName]="'SHIPPING_MANAGEMENT'"
          [actionButton]="isReadOnly"
          [allowResizing]="'Both'"
          [loading]="lineLoading"
          [viewableRowCount]="10"
          [deferResizing]="false"
          [collectionView]="linesCollectionView"
          [selectionColumn]="2"
          [isReadOnly]="isReadOnly"
          [columns]="[
            {
              header: 'product_group' | translate,
              binding: 'product_group',
              dataMap: productGroupDataMap,
              showDropDown: !isReadOnly
            },
            {
              header: 'package_type' | translate,
              binding: 'package_type',
              dataMap: packageTypeDataMap,
              showDropDown: !isReadOnly
            },
            {
              header: 'code' | translate,
              binding: 'material.code',
              action: materialSelectOnLine
            },
            {
              header: 'description' | translate,
              binding: 'material.description',
              isReadOnly: true
            },
            {
              header: 'quantity' | translate,
              binding: 'quantity',
              format: 'n0',
              min: 1,
              max: 999,
              width: 90
            },
            {
              header: 'user_count' | translate,
              binding: 'user_count',
              format: 'n0',
              min: 1,
              max: 999,
              width: 90
            }
          ]"
        >
        </kl-form-entry-grid>
      </accordion-group>
    </accordion>
  </form>
</kl-form-container>
